import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/main.scss";

///msal browser///
import { EventType } from "@azure/msal-browser";
import { msalInstance, b2cPolicies, loginRequest } from "@/authConfig";
import { msalPlugin } from "@/plugins/msalPlugin";
////accordion////

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_FAILURE &&
    event.error.errorMessage.includes("forgotten")
  ) {
    msalInstance.loginRedirect({
      authority: b2cPolicies.authorities.forgotPassword.authority,
    });
  }
  if (
    event.eventType === EventType.LOGIN_FAILURE &&
    event.error.errorMessage.includes("cancelled")
  ) {
    msalInstance.loginRedirect(loginRequest);
  }
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const app = createApp(App);

app.use(router);

app.use(msalPlugin, msalInstance); ///msal browser///
app.mount("#app");
